import React, { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts';
import { usePatientContext } from '../../contexts/patient-context';

export const PatientsDetailsPageComponent: FC = () => {
  const {
    user,
  } = useAuth();

  const { t } = useTranslation();

  const { patient } = usePatientContext();

  return (
    <Box style={{ padding: 16 }}>
      <Typography variant="h4">
        {t('Hi')}
        {' '}
        {user?.name}
      </Typography>
      <Typography variant="h4">
        {t('Birthday')}
        {' '}
        {patient?.dateOfBirth}
      </Typography>
    </Box>
  );
};
